import { useCallback, useEffect } from 'react';
import { useLayoutEffect } from '~app/hooks';
import { useSurveyFormatContext, useActiveViewContext } from './useSurveyFormatContext';

export default function ActiveViewScrollManager(): null {
  const { views } = useSurveyFormatContext();
  const { setActive, active, isAnimating } = useActiveViewContext();

  const findActiveAnchor = useCallback(() => {
    if (isAnimating.current) {
      return;
    }
    let newIdx = -1;
    if (window.scrollY === 0) {
      newIdx = 0;
    } else {
      const winMidpoint = window.innerHeight / 2;
      views.forEach((anchor, idx) => {
        const el = anchor?.ref.current;
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top > 0 && rect.top <= winMidpoint) {
            newIdx = idx;
          }
        }
      });
    }

    const currentAnchor = views[newIdx];

    if (currentAnchor && currentAnchor.ref !== active?.ref) {
      setActive(currentAnchor.name, true);
    }
  }, [active, views, setActive, isAnimating]);

  useLayoutEffect(() => {
    window.addEventListener('scroll', findActiveAnchor);
    return () => window.removeEventListener('scroll', findActiveAnchor);
  }, [findActiveAnchor]);

  useEffect(() => {
    findActiveAnchor();
  }, [views, findActiveAnchor]);

  return null;
}
